import type {
  WAbsoluteThemeComponentAssetStyleView,
  WInFlowThemeComponentAssetStyleView,
  WLengthView,
} from '@zola/svc-web-api-ts-client';
import { Device } from 'lib/universal/utils/devices';
import { getTabletSize, getMobileSize } from 'components/publicWebsiteV2/util/mappers';

export const getRelativeImgSize = (
  style: WAbsoluteThemeComponentAssetStyleView | WInFlowThemeComponentAssetStyleView,
  width: number,
  device?: Device
): number => {
  let calculatedWidth = 0;

  const assetDesktopSize = style?.responsive_size?.desktop?.width?.value;
  const assetDesktopUnit = style?.responsive_size?.desktop?.width?.unit;

  let val = style?.responsive_size?.desktop?.width?.value;
  let unit = style?.responsive_size?.desktop?.width?.unit;

  if (device?.isTablet()) {
    const assetTabletSize = style?.responsive_size?.tablet?.width?.value;
    const assetTabletUnit = style?.responsive_size?.tablet?.width?.unit;
    if (assetTabletSize) {
      val = assetTabletSize;
      unit = assetTabletUnit;
    } else if (
      assetDesktopSize &&
      assetDesktopUnit === (('PIXEL' as unknown) as WLengthView.UnitEnum)
    ) {
      val = getTabletSize(assetDesktopSize);
    }
  } else if (device?.isMobile()) {
    const assetMobileSize = style?.responsive_size?.mobile?.width?.value;
    const assetMobileUnit = style?.responsive_size?.mobile?.width?.unit;

    if (assetMobileSize) {
      val = assetMobileSize;
      unit = assetMobileUnit;
    } else if (
      assetDesktopSize &&
      assetDesktopUnit === (('PIXEL' as unknown) as WLengthView.UnitEnum)
    ) {
      val = getMobileSize(assetDesktopSize);
    }
  }

  if (val && unit === (('PERCENTAGE' as unknown) as WLengthView.UnitEnum)) {
    calculatedWidth = Math.round(width * (val / 100));
  } else if (val) {
    calculatedWidth = val;
  }

  return device?.isHighPixelDensity() ? calculatedWidth * 2 : calculatedWidth;
};

export default getRelativeImgSize;
